import "../../../../stylesheets/donation-options";
import { validateAmountToDonate } from "../../utils";

$(document).ready(function () {
  // Options selector
  $(".block-option").click(({ target }) => {
    const target_type = target.getAttribute("data-type");
    if (target_type == "options") {
      var amount = target.getAttribute("data-amount");
      const currency = target.getAttribute("data-currency");
      const block_id = target.getAttribute("data-block-id");
      $('.currency-selector-button[data-currency="' + currency + '"]').trigger(
        "click"
      );
      if (currency != 'clp') {
        amount = amount.replace(",", ".");
      }
      $("#donator_donation_transactions_attributes_0_amount").val(amount);
      validateAmountToDonate("once", currency);
      $(`div.block-option`).removeClass("active-option");
      $(`div.block-option[data-block-id="${block_id}"]`).toggleClass(
        "active-option"
      );
    }
  });

  $('.currency-selector-button').on('click', function () {
    var newCurrency = $(this).data('currency');
    $('.currency-selector-button').removeClass('btn-active');
    $(this).addClass('btn-active');
    update_price_cards_display(newCurrency);
  });

  $('.donation-type-select').on('click', function () {
    update_price_cards_display();
  });

  function update_price_cards_display(forcedCurrency) {
    var initialCurrency = forcedCurrency || $('.currency-selector-button.btn-active').data('currency');
    var selectedType = $('.donation-type-select .btn-active').data('type');
    var initialBoxesForCurrency = 0;
    if (selectedType === 'subscription') {
      $(".price-cards.payment-subscription").each(function () {
        if ($(this).data('currency') === initialCurrency) {
          initialBoxesForCurrency++;
        }
      });
    }
    else if (selectedType === 'once') {
      $(".price-cards.payment-once").each(function () {
        if ($(this).data('currency') === initialCurrency) {
          initialBoxesForCurrency++;
        }
      });
    }
    else {
      $(".price-cards").each(function () {
        if ($(this).data('currency') === initialCurrency) {
          initialBoxesForCurrency++;
        }
      });
    }
    if (initialBoxesForCurrency === 0) {
      $('.donations-options').hide();
    } else {
      $('.donations-options').show();
      $(".price-cards").each(function () {
        if ($(this).data('currency') === initialCurrency) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  };

  update_price_cards_display();
});
